import apiUrl from '../../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'module',
  components: {
    VueElementLoading,
    Paginate
  },
  props: [],
  data: function() {
    return {
      modulelist : [],
      userRolearr : [],
      approvalType : [],
      userRoleId : [],
      UserRolelist : [],
      moduleLevel : '',
      pageno: 0,
      pagecount: 0,
      resultCount:'',
      resultUserCount:'',
      moduleServiceName:'',
      userRoleId:'',
      //submodule:'',
      modulename:'',
      moduleList : [],
      moduleId:'',
      isLoading: false,
      pageLimit: 10,
      totalRows: 0,
      validListFlag: true,
      userRoleFlag: false,
      showAddModuleFlag: false,
      ModuleApprovalLevel: false,
      isLoading1 : false,
      isLoading2 : false,
      action : 'add'
  }
},
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
     this.getModuleMasterListandFilter();
     this.getModuleDropDownList();
  },
  methods: {
    checkAvaibiltityOfModule(){
      var userToken = window.localStorage.getItem('cargoAutoaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      axios({
              method: 'POST',
              'url': apiUrl.api_url + 'approval/checkmoduleexist',
              'data': {
                modulemasterid : this.modulename
              },
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          }).then(result => {
            if(result.data.code == 200){
              if(result.data.data.length == 0){
                return true;
              }else {
                  //this.$alertify.success("Module already exist!!!");
                  this.$alert("Module already exist!!!","","error");
                  this.modulename = '';
              }
            }
          }, error => {
            console.error('exception is:::::::::', error)
      })
    },
    getModuleDropDownList(){
      var userToken = window.localStorage.getItem('cargoAutoaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      axios({
              method: 'GET',
              'url': apiUrl.api_url + 'approval/modulemasterlistdropdown',
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then(result => {
            if(result.data.code == 200){
              this.moduleList = result.data.data.rows;

            }else {
              //this.$alertify.error("Unable to Fetch Module List");
              this.$alert("Unable to Fetch Module List.","","error");
            }
          }, error => {
            //this.$alertify.success("Unable to Fetch Model List");
            this.$alert("Unable to Fetch Module List.","","error");
            console.error('exception is:::::::::', error)
      })
    },
    openChangeStatusModal(val){
      this.userRoleId = val.modulemasterid
       this.ModuleApprovalLevel = true;
       this.getUserrolelistByModuleMasterId();
    },
    closeStatusModal(){
       this.ModuleApprovalLevel = false;
    },
    openUpdateModule(modulemasterid)
    {
      this.showAddModuleFlag = true;
      this.validListFlag = false;
      this.userRoleFlag = true;
      this.action = "update";
      let data = {}
      if(modulemasterid){
        data.modulemasterid = modulemasterid;
      }
      this.isLoading2 = true;
      var userToken = window.localStorage.getItem('cargoAutoaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      axios({
              method: 'POST',
              'url': apiUrl.api_url + 'approval/getModelAndRollDetailes',
              'data': data,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then(result => {
            this.isLoading2 = false;
            if(result.data.code == 200){
              this.modulename = result.data.data.modulemasterid;
              // this.submodule = result.data.data.submodule;
              this.moduleLevel = result.data.data.moduleapprovallevel;
              this.moduleId = result.data.data.modulemasterid;
              this.userRolearr = result.data.data.userinfo;
              for (var i = 0; i < result.data.data.userinfo.length; i++) {
                let email = result.data.data.userinfo[i].email.split("@");
                result.data.data.userinfo[i].email = email[0];
              }

            }else {
              //this.$alertify.error("Unable to Fetch Module info");
              this.$alert("Unable to Fetch Module info.","","error");
            }
          }, error => {
            //this.$alertify.success("Unable to Fetch Model Info");
            this.$alert("Unable to Fetch Module info.","","error");
            console.error('exception is:::::::::', error)
      })
    },
    searchModuleMaster() {
      this.pagecount = 0;
      this.totalRows = 0;
      this.resultCount = 0;
      this.pageno = 0;
      this.getModuleMasterListandFilter();
    },
    showAddModuleForm() {
      this.action = "add"
      this.showAddModuleFlag = true;
      this.validListFlag = false;
      this.userRoleFlag = false;
      this.clear();
    },
    hideAddReasonForm() {
      this.validListFlag = true;
      this.clearAddModuleForm();
      this.showAddModuleFlag = false;
    },
    clearAddModuleForm() {
      this.modulename = "";
      //this.submodule = "";
      this.moduleLevel = "";
      this.approvalType = [];
      this.userRolearr = [];
      this.userRoleFlag = false;
      document.getElementById("modulename").value= '';
      //document.getElementById("submodule").value= '';
      },
      setname(id, name){
        return name+id;
      },
      addUserRole(){
        this.$validator.validateAll().then((result) => {
          if(result){
            //this.addUpdateModuleMaster();
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
      },
      addArray(){
          this.userRolearr=[];
          for(let i=1;i<=this.moduleLevel;i++){
            let objTemp = {
              // userroleid : '',
              // approvaltype : '',
              // userroleerr : '',
              // approvaltypeerr : ''
              userrole : i,
              email : '',
              emailerror : ''
            }
            this.userRolearr.push(objTemp);
            this.userRoleFlag = true;
          }

      },
      chkRowsfoNumber(){
        var regexemil = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (this.userRolearr.length > 0) {
          var isErr = 0;
          for (var x = 0; x < this.userRolearr.length; x++) {
            if(this.userRolearr[x].email != '' && !this.userRolearr[x].email.includes("@xpressbees.com")){
              this.userRolearr[x].email = this.userRolearr[x].email + '@xpressbees.com';
            }
            if (regexemil.test(this.userRolearr[x].email) == false) {
              this.userRolearr[x].emailerror = 'Please Enter Correct Email format';
              isErr = 1;
            } else {
              this.userRolearr[x].emailerror = '';
            }
            if (this.userRolearr[x].email == '') {
              this.userRolearr[x].emailerror = 'Please Enter Email field';
              isErr = 1;
            } else {
              this.userRolearr[x].emailerror = '';
            }
          }
          if (isErr == 1) {
            return true;
          }

          let seen = new Set();
          var hasDuplicates = this.userRolearr.some(function(currentObject) {
              return seen.size === seen.add(currentObject.email).size;
          });
          if(hasDuplicates){
            //this.$alertify.error('Duplicate Email ID Please change');
            this.$alert("Duplicate Email ID Please change.","","error");
            return true;
          }
        } else {
          return true;
        }
      },
      chkRowsfoEmail(){
        var regexemil = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (this.userRolearr.length > 0) {
          for (var x = 0; x < this.userRolearr.length; x++) {
            var isErr = 0;

            if(this.userRolearr[x].email != '' && !this.userRolearr[x].email.includes("@xpressbees.com")){
              this.userRolearr[x].email = this.userRolearr[x].email + '@xpressbees.com';
            }
            if (regexemil.test(this.userRolearr[x].email) == false) {
              this.userRolearr[x].emailerror = 'Please Enter Correct Email format';
              isErr = 1;
            } else {
              this.userRolearr[x].emailerror = '';
            }
            if (this.userRolearr[x].email == '') {
              this.userRolearr[x].emailerror = 'Please Enter Email field';
              isErr = 1;
            } else {
              this.userRolearr[x].emailerror = '';
            }
            if (isErr == 1) {
              return true;
            }
          }
          let seen = new Set();
          var hasDuplicates = this.userRolearr.some(function(currentObject) {
              return seen.size === seen.add(currentObject.email).size;
          });
          if(hasDuplicates){
            //this.$alertify.error('Duplicate Email ID Please change');
            this.$alert("Duplicate Email ID Please change.","","error");
            return true;
          }
        } else {
          return true;
        }
      },
    addUpdateModuleMaster(){
       let userrolesDataArr = [];
      for(var i=0; i<this.userRolearr.length; i++){
        let userroles = {
          userrole:this.userRolearr[i].userrole,
          // 'userroleid' : this.userRolearr[i].userroleid,
          // 'approvaltype': this.userRolearr[i].approvaltype
          emailid : this.userRolearr[i].email,
      }
      if(this.userRolearr[i].userrolemasterid){
        userroles.userrolemasterid = this.userRolearr[i].userrolemasterid;
      }
       userrolesDataArr.push(userroles);
      }
      let data = {}
      data.modulemasterid = this.modulename;
      data.moduleApprovalLevel = this.moduleLevel;
      //data.subModule = this.submodule;
      data.CreatedBy = this.useremail;
      data.userroles = userrolesDataArr;
      let url = '';
      if(this.moduleId){
        data.modulemasterid = this.moduleId;
        url = 'approval/updateUserRoleandModel'
      }else {
        url = 'approval/savemodulesandroles'
      }
      var userToken = window.localStorage.getItem('cargoAutoaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      axios({
              method: 'POST',
              'url': apiUrl.api_url + url,
              'data': data,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          }).then((result) => {
            if(result.data.code == 200){
              let message = this.moduleId ? "Successfully update Module Master." :
              "Successfully Created Module Master.";
              //this.$alertify.success(message);
              this.$alert(message,"","success");
               this.showAddModuleFlag = true;
               this.validListFlag = true;
              this.hideAddReasonForm();
              this.getModuleMasterListandFilter();
              //this.getUserrolelistByModuleMasterId();

            }else {
              //this.$alertify.error(result.data.message);
              this.$alert(result.data.message,"","error");
            }
        })
        .catch((httpException) => {
              this.isLoading = false;
              //this.$alertify.success("Unable to Crete Module Master");
              this.$alert("Unable to Crete Module Master.","","error");
              console.error('exception is:::::::::', httpException)
        })
    },

    getModuleMasterListandFilter(){
      var userToken = window.localStorage.getItem('cargoAutoaccessuserdata')
      var myStr = userToken.replace(/"/g, '');

      let data = {
        offset : this.pageno,
        limit : 10
      }
      if(this.moduleServiceName){
        data.modulename = this.moduleServiceName;
      }
      this.isLoading = true;
      axios({
              method: 'POST',
              'url': apiUrl.api_url + 'approval/modulemasterlist',
              'data': data,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then(result => {
            this.isLoading = false;
            if(result.data.code == 200){
              this.modulelist = result.data.data.rows;
              let totalRows = result.data.data.count;
              this.resultCount = result.data.data.count;
              if (totalRows < 10) {
                  this.pagecount = 1;
              } else {
                  this.pagecount = Math.ceil(totalRows / 10)
              }
            }else {
              //this.$alertify.error("Unable to Fetch Module Master list");
              this.$alert("Unable to Fetch Module Master list.","","error");
            }
          }, error => {
            //this.$alertify.success("Unable to Fetch User list");
            this.$alert("Unable to Fetch Module Master list.","","error");
            console.error('exception is:::::::::', error)
      })
    },
    getUserrolelistByModuleMasterId(moduleId){
      this.ModuleApprovalLevel = true;
      var userToken = window.localStorage.getItem('cargoAutoaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      var data = {}
      this.UserRolelist = [];
      this.resultUserCount = 0;
      if(moduleId ){
        data.modulemasterid = moduleId
      }
      this.isLoading1 = true;
      axios({
              method: 'POST',
              'url': apiUrl.api_url + 'approval/userrolelist',
              'data': data,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then(result => {
            this.isLoading1 = false;
            if(result.data.code == 200){
               this.UserRolelist = result.data.data.rows;
               this.resultUserCount = result.data.data.count;
            }
          }, error => {
            //this.$alertify.success("Unable to Fetch User Role list");
            this.$alert("Unable to Fetch Module Master list.","","error");
            console.error('exception is:::::::::', error)
      })
    },
    getPaginationData(pageNum) {
     this.pageno = (pageNum - 1) * this.pageLimit;
     this.getModuleMasterListandFilter();
    },
    clear(){
      this.modulelist = [];
      this.moduleServiceName = '';
      this.pageno = 0;
      this.pagecount = 0;
      this.resultCount = '';
      this.$validator.reset();
      this.getModuleMasterListandFilter();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        let result1 = this.chkRowsfoEmail();
        if(result1 == true){
          return false
        }
        if(result){
          this.addUpdateModuleMaster(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/cargoclient/approvalflow/approvalflow-tab/module/module.component.js